<script setup>
import { RouterLink } from 'vue-router'
</script>

<template>
  <div class="welcome-container">
    <span class="eyebrow">Language practice that listens back</span>
    <h1>Welcome to GPTeacher</h1>
    <p>Practice numbers listening for free, or sign in for guided AI conversation.</p>
    <div class="home-actions">
      <RouterLink class="primary-action" to="/number-trainer">Try the Number Trainer</RouterLink>
      <RouterLink class="secondary-action" to="/login">Sign in to chat</RouterLink>
    </div>
  </div>
</template>

<style scoped>
.welcome-container {
  text-align: center;
  padding: clamp(3rem, 12vw, 8rem) 1rem;
}

.eyebrow {
  color: #7fd48d;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

h1 {
  margin-top: 0.45rem;
  color: #fff;
  font-size: clamp(2.5rem, 8vw, 4.7rem);
  font-weight: 750;
  letter-spacing: -0.045em;
  line-height: 1.05;
}

p {
  max-width: 620px;
  margin: 1rem auto 0;
  color: #aeb9ad;
  font-size: 1.1rem;
}

.home-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.8rem;
  margin-top: 1.7rem;
}

.primary-action,
.secondary-action {
  border-radius: 10px;
  font-weight: 700;
  padding: 0.75rem 1rem;
}

.primary-action {
  background: #63c174;
  color: #102414;
}

.secondary-action {
  border: 1px solid #4c594c;
  color: #d9e2d8;
}
</style>
